var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}}),_c('b-col',{attrs:{"md":"12"}})],1),_c('ModalReservation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }